module.exports = __webpack_public_path__ + "img/gongyingshang.595079ac.jpg";